export const SearchIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_47_528)">
        <path
          d="M12.4295 10.7556C13.401 9.4299 13.8361 7.78628 13.6478 6.15356C13.4595 4.52083 12.6617 3.01941 11.4139 1.94967C10.1661 0.879932 8.56046 0.32077 6.91813 0.384051C5.27579 0.447333 3.71792 1.12839 2.55617 2.29097C1.39442 3.45355 0.714474 5.01192 0.652367 6.65429C0.59026 8.29667 1.15057 9.90193 2.2212 11.1489C3.29183 12.3959 4.79383 13.1927 6.42669 13.3798C8.05955 13.567 9.70286 13.1307 11.0278 12.1582H11.0268C11.0569 12.1983 11.0891 12.2365 11.1252 12.2736L14.9879 16.1363C15.176 16.3246 15.4313 16.4304 15.6974 16.4305C15.9635 16.4306 16.2188 16.325 16.4071 16.1368C16.5954 15.9487 16.7012 15.6935 16.7013 15.4274C16.7014 15.1612 16.5957 14.9059 16.4076 14.7177L12.5449 10.8549C12.509 10.8186 12.4704 10.7851 12.4295 10.7546V10.7556ZM12.6883 6.89887C12.6883 7.62353 12.5456 8.34109 12.2683 9.01059C11.991 9.68009 11.5845 10.2884 11.0721 10.8008C10.5597 11.3132 9.95135 11.7197 9.28185 11.997C8.61235 12.2743 7.89478 12.4171 7.17012 12.4171C6.44546 12.4171 5.7279 12.2743 5.0584 11.997C4.3889 11.7197 3.78057 11.3132 3.26816 10.8008C2.75575 10.2884 2.34928 9.68009 2.07196 9.01059C1.79465 8.34109 1.65192 7.62353 1.65192 6.89887C1.65192 5.43535 2.2333 4.03177 3.26816 2.99691C4.30303 1.96204 5.7066 1.38066 7.17012 1.38066C8.63364 1.38066 10.0372 1.96204 11.0721 2.99691C12.1069 4.03177 12.6883 5.43535 12.6883 6.89887Z"
          fill="#0C0B0B"
        />
      </g>
      <defs>
        <clipPath id="clip0_47_528">
          <rect x="0.64856" y="0.37738" width="16.053" height="16.053" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg className="add-icon" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.79366 4.19755L7.79366 7.79378H4.19743V9.20622H7.79366L7.79366 12.8025L9.20611 12.8024L9.20611 9.20622H12.8023V7.79378H9.20611L9.20611 4.19755L7.79366 4.19755Z"
        fill="#289BEF"
      />
    </svg>
  );
};

export const WhiteAddIcon = () => {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.79378 4.43681L7.79378 8.03303H4.19756V9.44548H7.79378L7.79378 13.0417L9.20623 13.0417L9.20623 9.44548H12.8025V8.03304H9.20623L9.20623 4.43681L7.79378 4.43681Z"
        fill="#F2F7F9"
      />
    </svg>
  );
};

export const LogautIcon = () => {
  return (
    <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4637 6.78576C16.4637 5.92113 17.5094 5.48853 18.1202 6.10048L19.9792 7.96284C20.7835 8.7686 20.781 10.0742 19.9737 10.8769L18.1239 12.7162C17.5097 13.3269 16.4637 12.8918 16.4637 12.0257C16.4637 11.4879 16.0277 11.052 15.49 11.052H10.6708C9.76061 11.052 9.02273 10.3141 9.02273 9.4039C9.02273 8.49368 9.76061 7.7558 10.6708 7.7558H15.4936C16.0294 7.7558 16.4637 7.3215 16.4637 6.78576ZM12.3932 14.9019C13.0302 14.4729 13.9015 14.4796 14.4313 15.0355C14.9583 15.5885 14.9478 16.4723 14.3432 16.9391C12.7643 18.1585 11.0808 18.7681 9.29298 18.7681C6.68655 18.7681 4.4915 17.8723 2.70784 16.0806C0.92418 14.2889 0.0323486 12.0509 0.0323486 9.36644C0.0323486 7.68088 0.440729 6.12018 1.25749 4.68433C2.07425 3.24848 3.17628 2.11541 4.56357 1.28512C5.95086 0.45482 7.45527 0.0396729 9.07678 0.0396729C10.8984 0.0396729 12.6425 0.667356 14.309 1.92272C14.9159 2.37989 14.9367 3.26061 14.4125 3.81069C13.8932 4.35563 13.0389 4.36289 12.4181 3.93707C11.3607 3.21165 10.2529 2.84894 9.09479 2.84894C7.30513 2.84894 5.79472 3.49819 4.56357 4.7967C3.33242 6.09521 2.71685 7.68088 2.71685 9.55373C2.71685 11.3017 3.35044 12.8062 4.61762 14.0673C5.8848 15.3283 7.37119 15.9589 9.07678 15.9589C10.2415 15.9589 11.347 15.6065 12.3932 14.9019Z"
        fill="#EB5757"
      />
    </svg>
  );
};

export const DragFunctionIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3333 0.666687C6.84133 0.666687 4 3.50802 4 7.00002C4 8.81535 4.772 10.4495 6 11.6055L6 7.00002C6 4.61069 7.944 2.66669 10.3333 2.66669C12.6827 2.66669 14.5966 4.54724 14.6602 6.88153C14.6493 6.97426 14.6515 7.06805 14.6667 7.16018V11.6055C15.6638 10.6668 16.3528 9.41039 16.5794 8.00002H24.5859L22.5 10.086L23.9141 11.5L27.6211 7.79299C27.7433 7.69927 27.8422 7.5786 27.9101 7.44038C27.978 7.30216 28.0131 7.15012 28.0126 6.99613C28.0121 6.84213 27.976 6.69033 27.9072 6.55255C27.8384 6.41478 27.7387 6.29476 27.6159 6.20184L23.9141 2.50002L22.5 3.91408L24.5859 6.00002H16.5794C16.0976 2.98252 13.4843 0.666687 10.3333 0.666687ZM10.3333 4.00002C8.68833 4.00002 7.33333 5.35502 7.33333 7.00002L7.33333 16.9805C7.187 17.1925 6.73705 17.8325 6.13672 18.862C5.79124 19.4545 5.44116 20.0993 5.16667 20.7266C4.89217 21.3538 4.66667 21.9305 4.66667 22.6029C4.66667 23.9286 5.29542 25.1524 6.04948 26.2813C6.80354 27.4102 7.72439 28.4385 8.49219 29.2253C9.59623 30.3563 11.1891 30.8649 12.7422 30.5951L18.1823 29.6524C19.998 29.3374 21.5183 28.0925 22.1888 26.3776C22.783 24.8576 23.4903 23.0153 23.7812 22.0026C24.6787 18.8784 22.5872 15.7314 19.4935 14.905C19.3308 14.8611 19.1712 14.8261 19.0143 14.7969L19.0091 14.7956L13.3333 13.7669V7.00002C13.3333 5.35502 11.9783 4.00002 10.3333 4.00002ZM10.3333 6.00002C10.8977 6.00002 11.3333 6.43569 11.3333 7.00002V14.6029C11.3333 14.8372 11.4155 15.0642 11.5656 15.2441C11.7158 15.424 11.9244 15.5454 12.1549 15.5873L18.6523 16.763H18.6471C18.7614 16.7843 18.8722 16.8081 18.9753 16.836L18.9779 16.8373C21.0748 17.3975 22.4273 19.4734 21.8594 21.4505C21.6341 22.2343 20.9138 24.1448 20.3255 25.6498C19.908 26.7176 18.9694 27.4866 17.8411 27.6823L12.401 28.625H12.3997C11.4889 28.7832 10.5658 28.4878 9.92318 27.8294C9.20897 27.0976 8.35965 26.1366 7.71354 25.1693C7.06743 24.202 6.66667 23.2231 6.66667 22.6029C6.66667 22.515 6.7745 22.044 7 21.5287C7.2255 21.0134 7.5421 20.4206 7.86328 19.8698C8.50565 18.7682 9.15234 17.8425 9.15234 17.8425C9.26997 17.6746 9.33315 17.4746 9.33333 17.2696V7.00002C9.33333 6.43569 9.769 6.00002 10.3333 6.00002Z"
        fill="#949DB0"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const ThreePlusIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM5 5V19H19V5H5ZM13 17H11V13H7V11H11V7H13V11H17V13H13V17Z"
        fill="#414D65"
      />
    </svg>
  );
};

export const ThreeMinusIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM5 5V19H19V5H5ZM17 13H7V11H17V13Z"
        fill="#414D65"
      />
    </svg>
  );
};

export const CoolIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.2989 34.3966H8.70109C6.91817 34.3966 5.47282 32.9513 5.47282 31.1684V8.57055C5.47282 6.78763 6.91817 5.34229 8.70109 5.34229H31.2989C33.0818 5.34229 34.5272 6.78763 34.5272 8.57055V31.1684C34.5272 32.9513 33.0818 34.3966 31.2989 34.3966ZM8.70109 16.6412V31.1684H31.2989V16.6412H8.70109ZM8.70109 8.57055V13.4129H31.2989V8.57055H8.70109Z"
        fill="#283348"
      />
    </svg>
  );
};

export const AccordionCustomIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0066 5.03739L7.99995 9.04539L3.99329 5.03739L4.93595 4.09405L8.00262 7.16072L11.0693 4.09405L12.0066 5.03739ZM12 10.5707L12 11.9041L3.99995 11.9041L3.99995 10.5707L12 10.5707Z"
        fill="#3B465C"
      />
    </svg>
  );
};

export const MatchDisabledIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="17" height="17" rx="8.5" fill="#949DB0" />
      <g clipPath="url(#clip0_389_34485)">
        <path
          d="M6.25002 12.25C5.61782 12.2498 5.05358 11.8533 4.83923 11.2585C4.62488 10.6638 4.80644 9.99849 5.29319 9.59507C5.77994 9.19165 6.46738 9.13671 7.01202 9.45772L9.45777 7.01197C9.07515 6.36191 9.23551 5.52877 9.83208 5.06718C10.4287 4.60559 11.2754 4.65953 11.8086 5.19308C12.3417 5.72664 12.3951 6.5734 11.9331 7.16965C11.4711 7.7659 10.6378 7.92567 9.98802 7.54259L7.54264 9.98797C7.8162 10.4518 7.82013 11.0267 7.55296 11.4942C7.28579 11.9617 6.78851 12.2502 6.25002 12.25ZM6.25002 9.99997C5.83581 9.99997 5.50002 10.3358 5.50002 10.75C5.50002 11.1642 5.83581 11.5 6.25002 11.5C6.66423 11.5 7.00002 11.1642 7.00002 10.75C7.00002 10.3358 6.66423 9.99997 6.25002 9.99997ZM10.75 5.49997C10.3403 5.50038 10.0067 5.82953 10.0009 6.23922C9.99499 6.6489 10.319 6.98748 10.7285 6.99964C11.1381 7.01179 11.4816 6.69303 11.5 6.28372V6.43372V6.24997C11.5 5.83575 11.1642 5.49997 10.75 5.49997Z"
          fill="#F2F7F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_389_34485">
          <rect width="9" height="9" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MatchedIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="17" height="17" rx="8.5" fill="#289BEF" />
      <g clipPath="url(#clip0_389_34782)">
        <path
          d="M6.24996 12.25C5.61776 12.2498 5.05352 11.8533 4.83917 11.2585C4.62482 10.6638 4.80638 9.99849 5.29313 9.59507C5.77988 9.19165 6.46732 9.13671 7.01196 9.45772L9.45771 7.01197C9.07509 6.36191 9.23545 5.52877 9.83202 5.06718C10.4286 4.60559 11.2753 4.65953 11.8085 5.19308C12.3417 5.72664 12.395 6.5734 11.933 7.16965C11.471 7.7659 10.6377 7.92567 9.98796 7.54259L7.54258 9.98797C7.81613 10.4518 7.82007 11.0267 7.5529 11.4942C7.28573 11.9617 6.78844 12.2502 6.24996 12.25ZM6.24996 9.99997C5.83574 9.99997 5.49996 10.3358 5.49996 10.75C5.49996 11.1642 5.83574 11.5 6.24996 11.5C6.66417 11.5 6.99996 11.1642 6.99996 10.75C6.99996 10.3358 6.66417 9.99997 6.24996 9.99997ZM10.75 5.49997C10.3402 5.50038 10.0067 5.82953 10.0008 6.23922C9.99492 6.6489 10.3189 6.98748 10.7285 6.99964C11.138 7.01179 11.4815 6.69303 11.5 6.28372V6.43372V6.24997C11.5 5.83575 11.1642 5.49997 10.75 5.49997Z"
          fill="#F2F7F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_389_34782">
          <rect width="9" height="9" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TransformationIcon = () => {
  return (
    <svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.79718 4.21875L9.53763 6.02875C9.36677 7.22406 8.42719 8.16364 7.23187 8.3345L5.42188 8.59406V9.68719L7.23187 9.94675C8.42719 10.1176 9.36677 11.0572 9.53763 12.2525L9.79718 14.0625H10.8903L11.1499 12.2525C11.3207 11.0572 12.2603 10.1176 13.4556 9.94675L15.2656 9.68719V8.59406L13.4556 8.3345C12.2603 8.16364 11.3207 7.22406 11.1499 6.02875L10.8903 4.21875H9.79718ZM22.2969 4.21875L22.1307 5.38193C22.021 6.15044 21.4174 6.75539 20.6489 6.86508L19.4844 7.03125V7.73438L20.6476 7.90054C21.4161 8.01023 22.021 8.61381 22.1307 9.38232L22.2969 10.5469H23L23.1662 9.3837C23.2759 8.61518 23.8794 8.01023 24.6479 7.90054L25.8125 7.73438V7.03125L24.6493 6.86508C23.8808 6.75539 23.2759 6.15182 23.1662 5.3833L23 4.21875H22.2969ZM34.7265 5.62775C34.4773 5.63948 34.279 5.71611 34.1401 5.85434C34.1392 5.85525 34.1383 5.85617 34.1374 5.85709L6.24585 33.7486C5.14757 34.8469 5.14757 36.6288 6.24585 37.7271L8.47607 39.9573C9.57436 41.0563 11.3548 41.0563 12.4531 39.9573L40.3447 12.0657C40.3456 12.0648 40.3465 12.0639 40.3474 12.063C40.6336 11.7766 40.6522 11.2411 40.3999 10.5508C40.1476 9.86059 39.6406 9.06001 38.9683 8.29038C38.2961 7.52076 37.5019 6.83155 36.7258 6.34438C35.9497 5.85722 35.2416 5.60341 34.7265 5.62775ZM34.9957 8.9772C35.6062 9.80304 36.4014 10.5973 37.2273 11.2061L27.3396 21.0938L25.108 18.8635L34.9957 8.9772ZM34.25 27.4219L33.9177 29.7496C33.6983 31.2866 32.4898 32.4952 30.9527 32.7145L28.625 33.0469V34.4531L30.9527 34.7855C32.4898 35.0048 33.6983 36.2134 33.9177 37.7504L34.25 40.0781H35.6562L35.9886 37.7504C36.208 36.2134 37.4165 35.0048 38.9535 34.7855L41.2812 34.4531V33.0469L38.9535 32.7145C37.4165 32.4952 36.208 31.2866 35.9886 29.7496L35.6562 27.4219H34.25Z"
        fill="#949DB0"
      />
    </svg>
  );
};

export const TransformationButtonIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.51227 1.59375L3.41422 2.27753C3.34967 2.72909 2.99471 3.08404 2.54315 3.14859L1.85938 3.24664V3.65961L2.54315 3.75766C2.99471 3.82221 3.34967 4.17716 3.41422 4.62872L3.51227 5.3125H3.92523L4.02328 4.62872C4.08783 4.17716 4.44279 3.82221 4.89435 3.75766L5.57812 3.65961V3.24664L4.89435 3.14859C4.44279 3.08404 4.08783 2.72909 4.02328 2.27753L3.92523 1.59375H3.51227ZM8.23438 1.59375L8.1716 2.03317C8.13016 2.3235 7.90214 2.55204 7.61182 2.59348L7.17188 2.65625V2.92188L7.6113 2.98465C7.90163 3.02609 8.13016 3.25411 8.1716 3.54443L8.23438 3.98438H8.5L8.56277 3.54495C8.60421 3.25462 8.83223 3.02609 9.12256 2.98465L9.5625 2.92188V2.65625L9.12308 2.59348C8.83275 2.55204 8.60421 2.32402 8.56277 2.03369L8.5 1.59375H8.23438ZM12.93 2.12604C12.8359 2.13047 12.7609 2.15942 12.7085 2.21164C12.7081 2.21198 12.7078 2.21233 12.7075 2.21268L2.17065 12.7495C1.75575 13.1644 1.75575 13.8375 2.17065 14.2524L3.01318 15.095C3.42809 15.5101 4.10072 15.5101 4.51562 15.095L15.0524 4.55817C15.0528 4.55782 15.0531 4.55748 15.0535 4.55713C15.1616 4.44895 15.1686 4.24663 15.0733 3.98587C14.978 3.72511 14.7864 3.42267 14.5325 3.13192C14.2785 2.84118 13.9785 2.58081 13.6853 2.39677C13.3921 2.21273 13.1246 2.11684 12.93 2.12604ZM13.0317 3.39139C13.2623 3.70337 13.5628 4.00343 13.8748 4.2334L10.1394 7.96875L9.29636 7.12622L13.0317 3.39139ZM12.75 10.3594L12.6245 11.2387C12.5416 11.8194 12.085 12.276 11.5044 12.3588L10.625 12.4844V13.0156L11.5044 13.1412C12.085 13.2241 12.5416 13.6806 12.6245 14.2613L12.75 15.1406H13.2812L13.4068 14.2613C13.4897 13.6806 13.9462 13.2241 14.5269 13.1412L15.4062 13.0156V12.4844L14.5269 12.3588C13.9462 12.276 13.4897 11.8194 13.4068 11.2387L13.2812 10.3594H12.75Z"
        fill="#F2F7F9"
      />
    </svg>
  );
};

export const EditIcon = ({width= 13, height= 13, fill = '#949DB0'}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 13 13" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.39416 11.1471C2.24222 11.1468 2.09737 11.0828 1.99495 10.9705C1.89065 10.8592 1.83883 10.7086 1.8525 10.5567L1.9852 9.09743L8.11579 2.96902L10.0317 4.88435L3.9027 11.0122L2.44345 11.1449C2.42666 11.1466 2.40987 11.1471 2.39416 11.1471ZM10.4141 4.50139L8.49875 2.58606L9.64762 1.43718C9.74922 1.33547 9.88709 1.27832 10.0309 1.27832C10.1746 1.27832 10.3125 1.33547 10.4141 1.43718L11.563 2.58606C11.6647 2.68766 11.7218 2.82552 11.7218 2.96929C11.7218 3.11305 11.6647 3.25092 11.563 3.35252L10.4146 4.50085L10.4141 4.50139Z"
        fill={fill}
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 17.4736C13.6235 17.4736 17.4668 13.6387 17.4668 9.00684C17.4668 4.3833 13.6152 0.540039 8.9917 0.540039C4.35986 0.540039 0.533203 4.3833 0.533203 9.00684C0.533203 13.6387 4.36816 17.4736 9 17.4736ZM6.02002 12.6924C5.62988 12.6924 5.31445 12.377 5.31445 11.9868C5.31445 11.7959 5.39746 11.6299 5.53027 11.5054L8.00391 9.01514L5.53027 6.5249C5.39746 6.40869 5.31445 6.23438 5.31445 6.04346C5.31445 5.66162 5.62988 5.35449 6.02002 5.35449C6.21094 5.35449 6.37695 5.4292 6.50146 5.56201L8.9917 8.04395L11.4985 5.55371C11.6396 5.4043 11.7891 5.33789 11.9717 5.33789C12.3618 5.33789 12.6772 5.65332 12.6772 6.03516C12.6772 6.22607 12.6108 6.38379 12.4697 6.5166L9.97949 9.01514L12.4614 11.4888C12.5859 11.6216 12.6689 11.7876 12.6689 11.9868C12.6689 12.377 12.3535 12.6924 11.9634 12.6924C11.7642 12.6924 11.5981 12.6094 11.4736 12.4849L8.9917 9.99463L6.51807 12.4849C6.39355 12.6177 6.21094 12.6924 6.02002 12.6924Z"
        fill="#949DB0"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const BranchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
      <path
        fillOpacity="0.65"
        d="M13,14C9.64,14 8.54,15.35 8.18,16.24C9.25,16.7 10,17.76 10,19A3,3 0 0,1 7,22A3,3 0 0,1 4,19C4,17.69 4.83,16.58 6,16.17V7.83C4.83,7.42 4,6.31 4,5A3,3 0 0,1 7,2A3,3 0 0,1 10,5C10,6.31 9.17,7.42 8,7.83V13.12C8.88,12.47 10.16,12 12,12C14.67,12 15.56,10.66 15.85,9.77C14.77,9.32 14,8.25 14,7A3,3 0 0,1 17,4A3,3 0 0,1 20,7C20,8.34 19.12,9.5 17.91,9.86C17.65,11.29 16.68,14 13,14M7,18A1,1 0 0,0 6,19A1,1 0 0,0 7,20A1,1 0 0,0 8,19A1,1 0 0,0 7,18M7,4A1,1 0 0,0 6,5A1,1 0 0,0 7,6A1,1 0 0,0 8,5A1,1 0 0,0 7,4M17,6A1,1 0 0,0 16,7A1,1 0 0,0 17,8A1,1 0 0,0 18,7A1,1 0 0,0 17,6Z"
      />
    </svg>
  );
};

export const BranchIconGrey = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
      <path
        fill="#949DB0"
        d="M13,14C9.64,14 8.54,15.35 8.18,16.24C9.25,16.7 10,17.76 10,19A3,3 0 0,1 7,22A3,3 0 0,1 4,19C4,17.69 4.83,16.58 6,16.17V7.83C4.83,7.42 4,6.31 4,5A3,3 0 0,1 7,2A3,3 0 0,1 10,5C10,6.31 9.17,7.42 8,7.83V13.12C8.88,12.47 10.16,12 12,12C14.67,12 15.56,10.66 15.85,9.77C14.77,9.32 14,8.25 14,7A3,3 0 0,1 17,4A3,3 0 0,1 20,7C20,8.34 19.12,9.5 17.91,9.86C17.65,11.29 16.68,14 13,14M7,18A1,1 0 0,0 6,19A1,1 0 0,0 7,20A1,1 0 0,0 8,19A1,1 0 0,0 7,18M7,4A1,1 0 0,0 6,5A1,1 0 0,0 7,6A1,1 0 0,0 8,5A1,1 0 0,0 7,4M17,6A1,1 0 0,0 16,7A1,1 0 0,0 17,8A1,1 0 0,0 18,7A1,1 0 0,0 17,6Z"
      />
    </svg>
  );
};

export const InputIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
      <path
        d="M14.875 2.13208L6.37498 2.13208C5.59581 2.13208 4.95831 2.76958 4.95831 3.54875V6.375H6.37498V3.53458H14.875V13.4725H6.37498V10.625H4.95831V13.4654C4.95831 14.2446 5.59581 14.8679 6.37498 14.8679H14.875C15.6541 14.8679 16.2916 14.2446 16.2916 13.4654V3.54875C16.2916 2.7625 15.6541 2.13208 14.875 2.13208Z"
        fill="#3B465C"
      />
      <path
        d="M7.79165 11.3333L10.625 8.49999L7.79165 5.66666V7.79166H0.708313V9.20832H7.79165V11.3333Z"
        fill="#3B465C"
      />
    </svg>
  );
};

export const OutputIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
      <path
        d="M2.12496 14.8679L10.625 14.8679C11.4041 14.8679 12.0416 14.2304 12.0416 13.4513L12.0416 10.625L10.625 10.625L10.625 13.4654L2.12496 13.4654L2.12496 3.5275L10.625 3.5275L10.625 6.375L12.0416 6.375L12.0416 3.53459C12.0416 2.75542 11.4041 2.13209 10.625 2.13209L2.12496 2.13209C1.34579 2.13209 0.70829 2.75542 0.70829 3.53459L0.708291 13.4513C0.708291 14.2375 1.34579 14.8679 2.12496 14.8679Z"
        fill="#3B465C"
      />
      <path
        d="M13.4583 11.3333L16.2917 8.49999L13.4583 5.66666V7.79166H6.375V9.20832H13.4583V11.3333Z"
        fill="#3B465C"
      />
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9091 5H7.27273C6.57273 5 6 5.57273 6 6.27273V15.1818H7.27273V6.27273H14.9091V5ZM16.8181 7.54547H9.81808C9.11808 7.54547 8.54535 8.1182 8.54535 8.8182V17.7273C8.54535 18.4273 9.11808 19 9.81808 19H16.8181C17.5181 19 18.0908 18.4273 18.0908 17.7273V8.8182C18.0908 8.1182 17.5181 7.54547 16.8181 7.54547ZM9.81827 17.7273H16.8183V8.81818H9.81827V17.7273Z"
        fill="#3B465C"
        fillOpacity="0.3"
      />
    </svg>
  );
};
